module.exports = __webpack_public_path__ + "img/Golf.289206e5.png";